import { ENDPOINT, RELATIONSHIP_FIELD, RELATIONSHIP_NAME } from "../utils/constants";
import { request } from "../utils/request";
import { getCurrentUserId } from "../utils/util";

export const getUserEnrollments = () => {

    return request({
        url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}'`,
        method: 'get'
    })
}

export const getUserEnrollmentByCourseId = (courseId) => {

    return request({
        url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS} eq '${courseId}' and ${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}'`,
        method: 'get'
    })
}

export const updateUserEnrollmentByEnrollmentId = (enrollmentId, activeStatus) => {

    return request({
        url: `${ENDPOINT.ENROLLMENTS}/${enrollmentId}`,
        method: 'PATCH',
        data: {
            "active": activeStatus,
        }
    })
}

export const getUserEnrollmentByLearningPathId = (learningPathId) => {

    return request({
        url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.LEARNING_PATHS_IN_ENROLLMENTS} eq '${learningPathId}' and ${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}'`,
        method: 'get'
    })
}

export const getActiveCoursesByUserEnrollments = () => {

    return request({
        url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}' and active eq true and ${RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS} ne '0'&nestedFields=${RELATIONSHIP_NAME.COURSES_IN_ENROLLMENTS}`,
        method: 'get'
    })
}

export const getAllCoursesByUserEnrollments = async () => {
    const pageSize = 20;
    const baseUrl = `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}' and ${RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS} ne '0' and active eq true&nestedFields=${RELATIONSHIP_NAME.COURSES_IN_ENROLLMENTS}&pageSize=${pageSize}`;

    let items = [];
    let page = 1;
    let lastPage = 1;

    do {
        const response = await request({
            url: `${baseUrl}&page=${page}`,
            method: 'get',
        });

        if (!Array.isArray(response?.items) || response.items.length === 0) {
            break;
        }

        items = items.concat(response.items);
        lastPage = response.lastPage ?? page;
        page++;
    } while (page <= lastPage);

    return { items, totalCount: items.length, lastPage };
}

export const getCompletedAssets = async(courseId) => {

    const result = await getUserEnrollmentByCourseId(courseId);
    
    const completedAssetsIds = result?.items?.length > 0 ? result.items[0].completedAssetIds : [];  

    return completedAssetsIds
}

export const updateCompletedAssets = (userEnrollmentId, completedAssetIds, assetId) => {
    return request({
        url: `${ENDPOINT.ENROLLMENTS}/${userEnrollmentId}`,
        method: 'PATCH',
        data: {
            completedAssetIds: completedAssetIds ?  completedAssetIds += ',' + assetId : assetId
        }
    });
}

export const enrollToLearningPath = (learningPathId, stepId) => {
    return request({
      url: `${ENDPOINT.ENROLLMENTS}`,
      method: "post",
      data: {
        completedStepsIds: stepId,
				[RELATIONSHIP_FIELD.LEARNING_PATHS_IN_ENROLLMENTS]: learningPathId,
				[RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS]: getCurrentUserId(),
      },
    });
  };
  
  export const updateCompletedSteps = (userEnrollmentId, completedStepsIds, stepId) => {
    return request({
        url: `${ENDPOINT.ENROLLMENTS}/${userEnrollmentId}`,
        method: 'PATCH',
        data: {
            completedStepsIds: completedStepsIds ? completedStepsIds += ',' + stepId : stepId,
        }
    });
  };

